<template lang="pug">
    include ../../../media/pug/mixins.pug
    +b.SECTION.modal-content
        +e.P.text._paragraph._center
            +e.SPAN.info-text(v-html="payText")
            +e.V-ICON(
                name="help-circle"
                v-tooltip.bottom="{ content: helpText, classes: 'tooltip__modal-pay' }"
            )
        +e.UL.list_reverse._vertical._center._top
            +e.LI.item._with_margin
                +e.ROUTER-LINK.btn.btn._size_md._theme_transp._full(
                    v-bind:to="{ name: 'Enter', params: { id: $route.params.id } }"
                ) {{ $t('CLOSE') }}
            +e.LI.item._with_margin
                +e.BUTTON.btn.btn._size_md.btn_theme_fill._full(
                    v-on:click="$store.dispatch('closeModal')"
                ) {{ $t('CONTINUE') }}
</template>
<script>
export default {
    computed: {
        payText() {
            return 'Для данного документа доступно первые <b>64 стр.</b> (50%) для ознакомления';
        },
        helpText() {
            return 'Ознакомление с документом позволяет просмотреть <b>первые 64 стр.</b> документа'
                + ' без занесения данных о просмотре в ежедневную/ежемесячную статистику.';
        }
    }
};
</script>
